import SocialItem from "./social-item";
export default SocialItem;